(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cv = document.getElementById('vk-field');
  if (cv && cv.getContext) {
    var ctx = cv.getContext('2d'), W, H, dpr, pts = [], mouse = { x: -999, y: -999 };
    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, (W * H) / 16000));
      pts = [];
      for (var i = 0; i < n; i++) {
        pts.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - .5) * .18, vy: (Math.random() - .5) * .18, r: Math.random() * 1.2 + .3 });
      }
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        if (!reduce) { p.x += p.vx; p.y += p.vy; }
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0; if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        var dxm = p.x - mouse.x, dym = p.y - mouse.y, dm = Math.sqrt(dxm * dxm + dym * dym);
        var glow = dm < 160 ? 1 - dm / 160 : 0;
        ctx.fillStyle = 'rgba(255,255,255,' + (0.25 + glow * .7) + ')';
        ctx.fillRect(p.x, p.y, p.r + glow * 1.5, p.r + glow * 1.5);
        for (var j = i + 1; j < pts.length; j++) {
          var q = pts[j], dx = p.x - q.x, dy = p.y - q.y, d = dx * dx + dy * dy;
          if (d < 14000) {
            ctx.strokeStyle = 'rgba(255,255,255,' + (0.07 * (1 - d / 14000) + glow * .12) + ')';
            ctx.lineWidth = .6;
            ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); ctx.stroke();
          }
        }
      }
      if (!reduce) requestAnimationFrame(draw);
    }
    size(); draw();
    window.addEventListener('resize', function () { size(); if (reduce) draw(); });
    window.addEventListener('pointermove', function (e) { mouse.x = e.clientX; mouse.y = e.clientY; }, { passive: true });
  }

  var burger = document.querySelector('[data-vk-burger]'), nav = document.getElementById('vk-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var title = document.querySelector('[data-vk-glitch]');
  if (title && !reduce) {
    setInterval(function () {
      title.classList.remove('is-glitch'); void title.offsetWidth; title.classList.add('is-glitch');
    }, 5200);
  }

  var con = document.querySelector('[data-vk-console]');
  if (con) {
    var cells = Array.prototype.slice.call(con.querySelectorAll('.vk-cell'));
    var rows = con.querySelectorAll('.vk-console__row').length || 1;
    var pctEl = document.querySelector('[data-vk-pct]'), dayEl = document.querySelector('[data-vk-day]'), fill = document.querySelector('[data-vk-fill]');
    var cols = 14, col = 0, day = 1;
    function render() {
      var on = con.querySelectorAll('.vk-cell.on').length;
      var shown = rows * Math.max(col, 1);
      var pct = Math.round(on / shown * 100);
      if (pctEl) pctEl.textContent = isFinite(pct) ? pct : 0;
      if (dayEl) dayEl.textContent = (day < 10 ? '0' : '') + day;
      if (fill) fill.style.width = Math.min(100, col / cols * 100) + '%';
    }
    function step() {
      if (col >= cols) {
        cells.forEach(function (c) { c.classList.remove('on'); });
        col = 0;
      }
      for (var r = 0; r < rows; r++) {
        var c = cells[r * cols + col];
        if (c && Math.random() < (0.55 + col * 0.03)) c.classList.add('on');
      }
      col++; day = day >= 365 ? 1 : day + 1;
      render();
    }
    if (reduce) { for (var k = 0; k < 10; k++) step(); }
    else { for (var s = 0; s < 4; s++) step(); setInterval(step, 900); }
  }

  var form = document.getElementById('vk-buy-form');
  if (form) {
    var box = form.querySelector('[data-vk-consent]'), btn = form.querySelector('[data-vk-buy]'), hint = form.querySelector('[data-vk-consent-hint]'), label = form.querySelector('.vk-consent');
    var soldOut = btn && btn.disabled;
    function sync() {
      if (!btn || soldOut) return;
      btn.classList.toggle('is-locked', !box.checked);
      btn.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
      if (box.checked && hint) hint.hidden = true;
      if (box.checked && label) label.classList.remove('is-error');
    }
    if (box) { box.addEventListener('change', sync); sync(); }
    form.addEventListener('submit', function (e) {
      if (box && !box.checked) {
        e.preventDefault();
        if (hint) hint.hidden = false;
        if (label) { label.classList.remove('is-error'); void label.offsetWidth; label.classList.add('is-error'); }
        box.focus();
      }
    });
  }

  var gal = document.querySelector('[data-vk-gallery]');
  if (gal) {
    var slides = gal.querySelectorAll('.vk-gallery__slide'), thumbs = gal.querySelectorAll('.vk-gallery__thumb');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-index');
        Array.prototype.forEach.call(slides, function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === i); });
        Array.prototype.forEach.call(thumbs, function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }
})();
